import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FiltroSegmentacao } from '../interfaces/segmentacao/filtro-segmentacao.interface';
import { TipoGrafico } from '../enums/tipo-grafico.enum';
import { BaseStateService } from './base-state.service';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class FiltroSegmentacaoService extends BaseStateService {
  private readonly STORAGE_KEY = environment.filtroSegmentacaoKey;

  private readonly filtroInicial: FiltroSegmentacao = {
    tiposRetorno: [
      TipoGrafico.Oportunidades,
      TipoGrafico.Telefones,
      TipoGrafico.Emails,
      TipoGrafico.SituacaoCPF,
      TipoGrafico.PersonaGeracao,
      TipoGrafico.Score,
      TipoGrafico.PersonaDigital,
      TipoGrafico.FlagsTelefonia,
      TipoGrafico.FaixaSalarial,
      TipoGrafico.Palavras,
    ],
    abrangencia: ['FEDERAL', 'ESTADUAL', 'MUNICIPAL'],
    cidades: undefined,
    cargos: undefined,
    faixasSalariais: undefined,
    regimes: undefined,
    secretarias: undefined,
    contatos: undefined,
  };

  private filtroAtual: BehaviorSubject<FiltroSegmentacao>;

  constructor() {
    super();
    this.filtroAtual = new BehaviorSubject<FiltroSegmentacao>(this.getFiltroInicialCopy());
  }

  private getFiltroInicialCopy(): FiltroSegmentacao {
    return JSON.parse(JSON.stringify(this.filtroInicial));
  }

  private saveFiltroToStorage(filtro: FiltroSegmentacao): void {
    this.setItem(this.STORAGE_KEY, JSON.stringify(filtro));
  }

  atualizarFiltro(filtro: FiltroSegmentacao) {
  const filtroAtualizado = {
    ...filtro,
    tiposRetorno: this.filtroInicial.tiposRetorno
  };
  
  this.filtroAtual.next({ ...filtroAtualizado });
  this.saveFiltroToStorage(filtroAtualizado);
}

  obterFiltroAtual(): FiltroSegmentacao {
    return this.filtroAtual.getValue();
  }

  resetarFiltro() {
    this.removeItem(this.STORAGE_KEY);  
    this.filtroAtual.next(this.getFiltroInicialCopy());
  }

  getFiltroInicial(): FiltroSegmentacao {
    return JSON.parse(JSON.stringify(this.filtroInicial));
  }
}